import classNames from 'classnames'
import { jsonConvert } from '../../../../helpers/jsonConvert'
import { AnswerButton } from '../AnswerButton/AnswerButton'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork'
import s from './Missing.module.css'
import { formateTime } from '@/helpers/formateTime'
import Constructor from '@UI/New/Constructor'
import { useRef } from 'react'
import JsonPars from '@UI/JsonPars/JsonPars'

export const Missing = ({ type,  ...props }) => {
  switch (type) {
    case 'decided': return <Decided {...props} />
    case 'correction': return <Correction {...props} />
    default: return <Task hist={props?.hist}  {...props} />
  }
}

const Correction = ({ omissions }) => {
  return <div className={s.answerContainer}>
    <p className={classNames(s.text, s.textCorrection)}>
      {omissions?.map((el, i) => {
        if (el.answer === 1) return <span key={i} className={s.textWrap} >

          <JsonPars json={el.question} />
          {
              el.type === 'constructor' && (
                  <Constructor 
                    className={(classNames(s.constructorCorrection, s.constructorCorrectionInlineDisplay))}
                    value={[]}
                    prohibitEditing
                   />
              )
            }
            {
              el.type !== 'constructor' && <input className={classNames(s.booble, s.input)} disabled={true} placeholder='Напишите ответ' />
            }
            
          
        </span>
        return <span key={i} ><JsonPars json={el.question} /></span>
      })}
    </p>
  </div >
}

const Decided = ({ userRole, ...props }) => {
  const answer = jsonConvert(props?.params?.result?.answer, 'json')
  const correctAnswer = jsonConvert(props?.params?.result?.correct_answer, 'json')
  return <div className={s.answerContainer}>
    <p className={s.text}>
      {props?.answer_options?.map((el, i) => {
        
        if (el?.answer === 1) {
          const isConstructor = el.type === 'constructor';
          // const arrayСorrectAnswersWithoutIds = isConstructor ? correctAnswer[i]?.text.map(({ id, ...rest }) => rest) : [];
          // const arrayAnswersWithoutIds = isConstructor ? answer[i]?.text.map(({ id, ...rest }) => rest) : [];

          // const properly = isConstructor ? 
          //                     jsonConvert(arrayСorrectAnswersWithoutIds) === jsonConvert(arrayAnswersWithoutIds) : correctAnswer[i]?.text === answer[i]?.text;
          const isCorrect = isConstructor ? answer[i]?.is_correct : correctAnswer[i]?.text === answer[i]?.text;
          return (
            <span className={s.answerWrapper} key={i} >
              <span className={s.answerQuestion}><JsonPars json={el.question} /></span>
              {
                !isConstructor && (
                  <span className={classNames(s.booble, { [s.accent]: isCorrect }, { [s.red]: !isCorrect })}>
                      {i + 1} {answer[i]?.text}  
                    </span>
                )
              }
              {
                isConstructor && (
                    <span className={classNames(s.booble, s.boobleConstructor, { [s.accent]: isCorrect }, 
                                                                                { [s.red]: !isCorrect })}>
                      {i + 1} <Constructor 
                                  value={(answer[i]?.text && Array.isArray(answer[i]?.text)) ? answer[i]?.text : []}
                                  prohibitEditing
                                  className={(classNames(s.constructorCorrection, s.constructorAnswers))}/> 
                    </span>
                )
              }

            </span>
          )
        }
        return <span key={i} ><JsonPars json={el.question} /></span>
      })}
    </p>

    <div className={s.answerWrap}>
      <span className={classNames(s.capsuleLeft)}>Правильные ответы</span>
      {correctAnswer.length > 0 && correctAnswer?.map((el, i) => {
        return (
          <>
            {
              el.type === 'constructor' && <div style={{display: 'flex', gap: '5px'}}>
                {i + 1})
                <Constructor 
                  value={(el.text && Array.isArray(el.text)) ? el.text : []}
                  prohibitEditing
                  className={s.constructor} />
              </div>
            }
            {
              el.type !== 'constructor' && <span>{i + 1}) <span key={i} className={s.capsuleRight}>{el.text}</span></span>
            }
          </>
        )
      })}
    </div>
    {props?.params?.result?.time_spent &&
      <div className={s.estimation}>
        <span className={s.boobleSpent}>Потрачено время</span>
        <span className={s.boobleSpent}> {formateTime(props?.params?.result?.time_spent)}</span>
      </div>
    }
  </div >
}

const Task = ({  params,hist, userRole, ...props }) => {
  const { onAnswer, answer, status, hint, video, videoType, correctAnswer } = useTaskHomeWork(params,  { ...props, type: 'arr' })

  const change = (state, index) => {
    const newList = [...answer.get]
    newList[index] = state
    answer.set(newList)
  }
  
  return <>
    <p className={classNames(s.text, s.textWrap)}>
      {props.answer_options?.map((el, i) => {
        if (el.answer === 1) return <Item key={i} type={el.type} userRole={userRole} status={status} value={answer.get[i]} change={e => change(e, i)} {...el} />
        return <span key={i} ><JsonPars json={el.question} /></span>
      })}
    </p>


    {correctAnswer &&  hist !== '?redo=ok' &&  params.type !== 'control' && <div className={s.answerWrapTask}>
      <span className={classNames(s.capsuleLeft)}>Правильные ответы</span>
      {correctAnswer?.map((el, i) => {
        return (
          <>
            {
              el.type === 'constructor' && <div style={{display: 'flex', gap: '5px'}}>
                {i + 1})
                <Constructor 
                  value={(el.text && Array.isArray(el.text)) ? el.text : []}
                  prohibitEditing
                  className={s.constructor} />
              </div>
            }
            {
              el.type !== 'constructor' && <span>{i + 1}) <span key={i} className={s.capsuleRight}>{el.text}</span></span>
            }
          </>
        )
      })}
    </div>}

    <AnswerButton hintForChild={params.hintForChild} hintAfterAllAttempts={props.hint_after_all_attempts} {...{ status, answer, onAnswer, hint, video, videoType }} />
  </>
}

const Item = ({ value, answer, change, type, allowed, status, state, userRole, ...props }) => {

  const constructorRef = useRef(null);
  
  let onChange = e => {
    const input = e.target
    const value = input.value;
    change({ text: value })

    if (value.length < 50) {
      const div = input.nextSibling
      div.innerText = value
      const width = div.clientWidth
      input.style.width = width + 'px'
    }
  }
  
  const onChangeConstructor = (value) => {
    change({ text: value })
    if (value.length > 3) {
      const width = constructorRef.current.clientWidth
      constructorRef.style.width = width + 'px'
    }
  }

  return <>
    <JsonPars json={props.question} />
    {
      type === 'constructor' && (
        <div className={s.constructorWrapper} ref={constructorRef}>
          <Constructor 
            value={(value?.text && Array.isArray(value?.text)) ? value?.text : []}
            edit={(value) => onChangeConstructor(value)}
            prohibitEditing={(status > 4 || userRole === 'parent')}
            className={classNames({[s.constructorCorrection]: (status > 4 || userRole === 'parent')}, s.constructor)} />
        </div>
      )
    }
      
    {
      type !== 'constructor' && (
        <span className={s.wrapper}>
          <input
            className={classNames(
              s.booble,
              s.input,
              // { [s.accent]: (status === 'chance' || !allowed) && state?.isRight },
              // { [s.red]: (status === 'chance' || !allowed) && !state?.isRight }
            )}
            value={value?.text ?? ''}
            disabled={status > 4 || userRole === 'parent'}
            placeholder='Напишите ответ'
            onChange={onChange} />
          <span className={s.booble}>Напишите ответ</span>
        </span>
      )
    }
      
  </>
}
